'use strict';

function valueIsNotInfinite(m) {
  return m !== -Infinity && m !== Infinity;
}

module.exports = valueIsNotInfinite;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/range/internal/valueIsNotInfinite.js
// module id = 396
// module chunks = 0